(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Nav ───────────────────────────────────────────────────────────────────
  function initNav() {
    var nav = document.getElementById('rl-nav');
    if (!nav) return;
    function update() { nav.classList.toggle('s', window.scrollY > 40); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ── Assembly scroll-scrub ─────────────────────────────────────────────────
  // Canvas + seeked pattern: the <video> stays in the DOM (1×1px, opacity 0.01)
  // for decoding. Frames are painted to <canvas> only after the 'seeked' event
  // fires — that is the only reliable cross-browser signal that a new frame is
  // ready. A pendingTime variable collapses rapid scroll events into a single
  // seek chain so the decoder is never flooded with overlapping seeks.
  function initAssemblyScrub() {
    var wrap = document.getElementById('rl-assembly-scroll');
    var vid  = document.getElementById('rl-assembly-vid');
    var cvs  = document.getElementById('rl-assembly-canvas');
    var pf   = document.getElementById('rl-asm-pf');
    var caps = document.querySelectorAll('[data-asm-start]');

    if (!wrap || !vid || !cvs) return;

    var KNOWN_DUR = 4.004; // rl-assembly-4k-scrub.mp4: 96 frames, 1920×1080, all keyframes

    if (REDUCED) {
      caps.forEach(function (el) { el.classList.add('visible'); });
      return;
    }

    var ctx         = cvs.getContext('2d');
    var seeking     = false;
    var pendingTime = null;
    var rafPending  = false;
    var setupDone   = false;

    function resizeCanvas() {
      var w = cvs.offsetWidth  || window.innerWidth;
      var h = cvs.offsetHeight || window.innerHeight;
      if (cvs.width !== w || cvs.height !== h) {
        cvs.width  = w;
        cvs.height = h;
      }
    }

    function drawFrame() {
      resizeCanvas();
      var cw = cvs.width;
      var ch = cvs.height;
      var vw = vid.videoWidth  || 1920;
      var vh = vid.videoHeight || 1080;
      // object-fit: cover — scale to fill canvas, center-crop the source
      var scale = Math.max(cw / vw, ch / vh);
      var sw = cw / scale;
      var sh = ch / scale;
      var sx = (vw - sw) / 2;
      var sy = (vh - sh) / 2;
      ctx.drawImage(vid, sx, sy, sw, sh, 0, 0, cw, ch);
    }

    function seekTo(t) {
      if (seeking) { pendingTime = t; return; }
      var dur = (vid.duration && isFinite(vid.duration) && vid.duration > 0)
                  ? vid.duration : KNOWN_DUR;
      t = Math.max(0, Math.min(t, dur - 0.001));
      if (Math.abs(vid.currentTime - t) < 0.001) { drawFrame(); return; }
      seeking = true;
      try { vid.currentTime = t; } catch (e) { seeking = false; }
    }

    vid.addEventListener('seeked', function () {
      drawFrame();
      seeking = false;
      if (pendingTime !== null) {
        var next = pendingTime;
        pendingTime = null;
        seekTo(next);
      }
    });

    function progress() {
      var rect = wrap.getBoundingClientRect();
      var h    = wrap.offsetHeight - window.innerHeight;
      return h > 0 ? Math.max(0, Math.min(1, -rect.top / h)) : 0;
    }

    function tick() {
      rafPending = false;
      var p   = progress();
      var dur = (vid.duration && isFinite(vid.duration) && vid.duration > 0)
                  ? vid.duration : KNOWN_DUR;

      seekTo(p * dur);

      if (pf) pf.style.width = (p * 100) + '%';

      caps.forEach(function (el) {
        var s = parseFloat(el.dataset.asmStart);
        var e = parseFloat(el.dataset.asmEnd);
        el.classList.toggle('visible', p >= s && p <= e);
      });
    }

    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(tick);
      }
    }

    function onResize() {
      resizeCanvas();
      drawFrame(); // repaint with new dimensions
    }

    function setup() {
      if (setupDone) return;
      setupDone = true;
      vid.pause();
      resizeCanvas();
      seekTo(0);
      tick();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }

    if (vid.readyState >= 2) {
      setup();
    } else {
      vid.addEventListener('loadeddata',     setup, { once: true });
      vid.addEventListener('canplay',        setup, { once: true });
      vid.addEventListener('canplaythrough', setup, { once: true });
      if (vid.networkState === 0) vid.load();
    }

    vid.addEventListener('error', function () {
      caps.forEach(function (el) { el.classList.add('visible'); });
    });
  }

  // ── Scroll reveals ────────────────────────────────────────────────────────
  function initReveals() {
    var els = document.querySelectorAll('.rl-rv');
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });

    els.forEach(function (el) { io.observe(el); });
  }

  // ── FAQ accordion ─────────────────────────────────────────────────────────
  function initFaq() {
    var items = document.querySelectorAll('.rl-faq-item');
    items.forEach(function (item) {
      var btn  = item.querySelector('.rl-faq-q');
      var body = item.querySelector('.rl-faq-body');
      if (!btn || !body) return;

      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.rl-faq-q').setAttribute('aria-expanded', 'false');
          var b = i.querySelector('.rl-faq-body');
          if (b) b.style.maxHeight = null;
        });
        if (!wasOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    var first = items[0];
    if (first) {
      first.classList.add('open');
      var fb = first.querySelector('.rl-faq-q');
      var fbb = first.querySelector('.rl-faq-body');
      if (fb) fb.setAttribute('aria-expanded', 'true');
      if (fbb) fbb.style.maxHeight = fbb.scrollHeight + 'px';
    }
  }

  // ── Waitlist form ─────────────────────────────────────────────────────────
  function initWaitlist() {
    var form      = document.getElementById('rl-waitlist-form');
    var googleBtn = document.getElementById('rl-google-btn');
    var status    = document.getElementById('rl-waitlist-status');
    var cfg       = window.RILUM_CONFIG || {};
    var sbClient  = null;

    if (cfg.supabaseUrl && cfg.supabaseKey && window.supabase) {
      sbClient = window.supabase.createClient(cfg.supabaseUrl, cfg.supabaseKey);
    }

    function setStatus(msg, cls) {
      if (!status) return;
      status.textContent = msg;
      status.className = 'rl-status' + (cls ? ' ' + cls : '');
    }

    function addToWaitlist(payload) {
      if (!cfg.supabaseUrl || !cfg.supabaseKey) {
        setStatus('Waitlist is being connected. Please check back shortly.', 'err');
        return Promise.resolve();
      }
      return fetch(cfg.supabaseUrl.replace(/\/$/, '') + '/rest/v1/waitlist_signups', {
        method: 'POST',
        headers: {
          apikey:         cfg.supabaseKey,
          Authorization:  'Bearer ' + cfg.supabaseKey,
          'Content-Type': 'application/json',
          Prefer:         'return=minimal'
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 409) { setStatus('You are already on the RILUM waitlist.', 'ok'); return; }
        if (!res.ok) throw new Error();
        setStatus('You are on the waitlist. We will be in touch.', 'ok');
      }).catch(function () {
        setStatus('Could not save your request. Please try again.', 'err');
      });
    }

    // Detect Google OAuth callback and auto-submit to waitlist
    if (sbClient) {
      sbClient.auth.getSession().then(function (result) {
        var session = result.data && result.data.session;
        if (session && session.user && !sessionStorage.getItem('rl-wl-submitted')) {
          sessionStorage.setItem('rl-wl-submitted', '1');
          addToWaitlist({
            email:      session.user.email,
            name:       (session.user.user_metadata && session.user.user_metadata.full_name) || null,
            source:     'google-oauth',
            page_url:   window.location.href,
            user_agent: navigator.userAgent
          });
        }
      });
    }

    if (googleBtn) {
      googleBtn.addEventListener('click', function () {
        if (!sbClient) { setStatus('Google sign-in is not configured yet.', 'err'); return; }
        googleBtn.disabled = true;
        googleBtn.querySelector('span') && (googleBtn.querySelector('span').textContent = 'Redirecting…');
        sbClient.auth.signInWithOAuth({
          provider: 'google',
          options: { redirectTo: window.location.href }
        }).catch(function () {
          setStatus('Could not start Google sign-in. Try the email option below.', 'err');
          googleBtn.disabled = false;
          googleBtn.querySelector('span') && (googleBtn.querySelector('span').textContent = 'Continue with Google');
        });
      });
    }

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn   = form.querySelector('button[type="submit"]');
      var email = String((form.elements['email'] && form.elements['email'].value) || '').trim().toLowerCase();
      if (!email) { setStatus('Enter your email address to join the waitlist.', 'err'); return; }
      if (btn) { btn.disabled = true; btn.textContent = 'Joining…'; }
      setStatus('');
      addToWaitlist({
        email:      email,
        name:       null,
        source:     'shoprilum-homepage',
        page_url:   window.location.href,
        user_agent: navigator.userAgent
      }).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Get Early Access'; }
        form.reset();
      });
    });
  }

  // ── Product modal ─────────────────────────────────────────────────────────
  function initProductModal() {
    var modal    = document.getElementById('rl-modal');
    var cards    = document.querySelectorAll('.rl-pcard');
    var tabs     = document.querySelectorAll('.rl-modal__tab');
    var panels   = document.querySelectorAll('.rl-modal__body');
    var closeBtn = modal ? modal.querySelector('.rl-modal__close') : null;
    var backdrop = modal ? modal.querySelector('.rl-modal__backdrop') : null;

    if (!modal) return;

    function switchPanel(productId) {
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== productId; });
      tabs.forEach(function (t) { t.classList.toggle('active', t.dataset.modalTarget === productId); });
    }

    function openModal(productId) {
      switchPanel(productId);
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('open'); });
      document.body.style.overflow = 'hidden';
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }

    function closeModal() {
      modal.classList.remove('open');
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { openModal(card.dataset.product); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(card.dataset.product); }
      });
    });

    // Any element with data-open-modal (e.g. the product hero section)
    document.querySelectorAll('[data-open-modal]').forEach(function (el) {
      el.addEventListener('click', function () { openModal(el.dataset.openModal); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(el.dataset.openModal); }
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { switchPanel(tab.dataset.modalTarget); });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  // Guard against defer-on-body: if DOMContentLoaded already fired, run now.
  function boot() {
    initNav();
    initAssemblyScrub();
    initReveals();
    initFaq();
    initWaitlist();
    initProductModal();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
